import { lazy } from 'react';

export const ModuleList = lazy(() => import('./module/ModuleList'));
export const ActionList = lazy(() => import('./action/ActionList'));
export const AddAction = lazy(() => import('./action/AddAction'));
export const UpdateAction = lazy(() => import('./action/UpdateAction'));
export const Permission = lazy(() => import('./permission/Permission'));
export const UserRoleList = lazy(() => import('./user_role/UserRoleList'));
export const EntityPermissionList = lazy(() => import('./entity_permission/EntityPermissionList'));
export const GlobalControl = lazy(() => import('./global_control/GlobalControl'));
export const Services = lazy(() => import('./services/Services'));
export const GlobalSettings = lazy(() => import('./global_settings/GlobalSettings'));
export const IpAndAccess = lazy(() => import('./ip_and_access/IpAndAccess'));